<section class="volvo tabMobSidePadding">
    <div id="contract">
        <volvo-allservices-page></volvo-allservices-page>
        <div class="marginB16">
            <h2 class="pageHeading-h2Heading marginB8">
                {{ "uk/components/footer/serviceContracts" | lowercase | translate }}
            </h2>

            <p class="volvo-text">
                <span class="volvo-text-medium">
                    {{ "uk/pages/services/serviceContracts/text1" | lowercase | translate }}
                </span>{{ "uk/pages/services/serviceContracts/text2" | lowercase | translate }}
            </p>

            <br>
           
            <p class="volvo-text">
                {{ "uk/pages/services/serviceContracts/text3" | lowercase | translate }}
            </p>
        </div>
    </div>
    
    <div class="volvo-list marginB48 contractGap">
        <div *ngFor="let list of contractList">
            <div>
                <div class="marginB8">
                    <div class="volvo-list-titleContract">
                        <img [src]="list.img" alt="{{ 'list.type' | lowercase | translate }}" />
                    </div>
                </div>
                <div class="volvo-list-displayContract-padding contractMaxWidth">
                    <p class="volvo-list-titleContract marginB8">{{ list.type | lowercase | translate }}</p>
                    <p class="volvo-text" id="customisation">{{ list.name | lowercase | translate }}</p>
                </div>
            </div>
        </div>
    </div>
</section>